import { Field, useField } from 'formik';
import * as Yup from 'yup';
import { Typography, IconButton, Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { useState, useCallback } from 'react';
import { HelpOutline, Close } from '@mui/icons-material';
import styled from 'styled-components';

import { FormRowsDivider, InputField } from '../../../fields';
import { SendTestLead } from '../../send-test-lead';

export const BitrixIntegration = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [{ value: bitrixIntegration }, { error }] = useField('campaign.bitrixIntegration');
  const [{ value: campaignId }] = useField('campaign.id');

  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <>
      <FormRowsDivider sx={{ marginTop: '20px' }} />

      <Typography sx={{ fontWeight: 'bold', marginBottom: '12px' }}>Bitrix24</Typography>

      <Field
        name="campaign.bitrixIntegration.webhookUrl"
        component={InputField}
        label="Bitrix24 webhook url"
        placeholder="https://{your_domain}.bitrix24.ru/rest/1/wbqy1kpp3ulf7zir/crm.lead.add.json"
        className="form-field webhook-input"
        validate={(value: string) => validate(value, Yup.string().url().nullable())}
      />

      <IconButton
        onClick={(event) => {
          event.preventDefault();
          setModalVisible(true);
        }}
      >
        <HelpOutline />
      </IconButton>

      <br />
      <br />

      {bitrixIntegration?.webhookUrl && !error && (
        <SendTestLead
          integrationId="bitrix"
          campaignId={campaignId}
          params={{ webhookUrl: bitrixIntegration.webhookUrl }}
        />
      )}

      <Dialog
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
        maxWidth="lg"
      >
        <DialogTitle>
          <CloseModalButton onClick={handleModalClose}>
            <Close />
          </CloseModalButton>
        </DialogTitle>

        <DialogContent>
          Вам нужно создать входящий веб-хук с <b>правами на CRM</b>. В качестве метода укажите <b>crm.lead.add</b>
          <br />
          <Button
            href="https://blog.embedgames.app/articles/integraciya-s-bitrix"
            target="_blank"
            sx={{ marginLeft: '-8px' }}
          >
            Подробнее
          </Button>
          <br />
          <br />
          <ScreenshotImage src="https://cdn2.embedgames.app/images/bitrix.png" />
        </DialogContent>
      </Dialog>
    </>
  );
};

const CloseModalButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const ScreenshotImage = styled.img`
  width: 940px;
  min-height: 680px;
`;
